import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";
import AlertService from "@/core/services/alert.service";
import router from '@/router'

// action types

export const PAGINATE_ALL_USERS = "getPaginatedUsers";
export const ALL_USERS = "getAllUsers";
export const ALL_NOTIFICATIONS = "getAllNotifications";
export const FIND_BY_USER_NAME = "findByUserName";
export const CREATE_USER_FORM = "createUserForm";
export const DELETE_USER = "deleteUser";
export const APPROVE_USER = "approveUser";
export const EXPEL_USER = "expelUser";
export const RESIGN_USER = "resignUser";
export const DEATH_USER = "deathUser";
export const GET_USER_DATA = "getUserData";
export const CREATE_USER = "createUser";
export const UPDATE_USER = "updateUser";
export const ADD_ROLE_TO_USER = "addRoleToUser";
export const DELETE_ROLE_FROM_USER = "deleteRoleFromUser";
export const ADD_PERMISSION_TO_USER = "addPermissionToUser";
export const DELETE_PERMISSION_FROM_USER = "deletePermissionFromUser";


// mutation types

export const SET_PAGINATED_USERS = "setPaginatedUsers";
export const SET_ALL_USERS = "setAllUsers";
export const SET_USER_DATA = "setUserData";
export const SET_USER_META = "setUserMeta";
export const SET_USER_ERROR = "setUserError";
export const SET_USER_LOADING = "setUserLoading";
export const CLEAR_USER_ERROR = "clearUserError";
export const SET_IS_DISABLED_USER = "setIsDisabledUser";


const state = {
    users: [],
    paginatedUsers: [],
    user_data: {},
    meta_user : {
        totalPages: 0,
        total: 0,
        from: 0,
        to: 0,
    },
    errors: [],
    loading: false,
    isDisabled: false
    };

const getters = {
   
    paginateAllUsers(state) {
        return state.paginatedUsers;
    },

    allUsers(state) {
        return state.users;
    },

    getUserData(state) {
        return state.user_data;
    },

    meta_user(state) {
        return state.meta_user;
    },

};

const actions = {
 
    [PAGINATE_ALL_USERS](context, payload) {
        context.commit(SET_IS_DISABLED_USER, false);
        context.commit(SET_USER_LOADING, true);
        JwtService.getToken();
        ApiService.setHeader();
        ApiService.get(`/users?size=${payload.itemsPerPage}&page=${payload.pageNumber}&sortBy=${payload.sortBy}&sortDesc=${payload.sortDesc}&searchText=${payload.search}&check=${payload.x}`)
        .then(({ data }) => {
            
            if(data == 403) {
                context.commit(SET_USER_LOADING, false);
                router.push('nopermission');
            }
            else {
                context.commit(SET_PAGINATED_USERS, data);
                context.commit(SET_USER_META, data);
                context.commit(SET_USER_LOADING, false);
            }
            
        })
        .catch(( response ) => {
            context.commit(SET_USER_LOADING, false);
            context.commit(SET_USER_ERROR, response.errors);
        });
        
    },

    [FIND_BY_USER_NAME](context, payload) {
        context.commit(SET_IS_DISABLED_USER, false);
        context.commit(SET_USER_LOADING, true);
        JwtService.getToken();
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.get(`/findByUserName?searchText=${payload.searchText}&check=${payload.x}`)
            .then((response) => {
                resolve(response);
            })
        });
    },


    [ALL_USERS]() {
        return new Promise(resolve => {
            ApiService.get('/usersAll')
            .then((response) => {
                resolve(response);
            })
        });
    },

    [ALL_NOTIFICATIONS]() {
        return new Promise(resolve => {
            ApiService.get('/userNotifications')
            .then((response) => {
                resolve(response);
            })
        });
    },

    [CREATE_USER_FORM](context) {
        context.commit(SET_USER_LOADING, false);
        context.commit(SET_USER_ERROR, false);
        context.commit(SET_IS_DISABLED_USER, false);
    },

    [GET_USER_DATA](context, payload) {
        context.commit(SET_IS_DISABLED_USER, true);
        context.commit(SET_USER_LOADING, true);
        context.commit(CLEAR_USER_ERROR);
        return new Promise(resolve => {
            ApiService.get(`/user/${payload.id}`)
            .then(( response ) => {
                if(response.data == 403) {
                    context.commit(SET_USER_LOADING, false);
                    router.push('/nopermission');
                }
                else {
                    context.commit(SET_USER_DATA, response.data);
                    context.commit(SET_USER_LOADING, false);
                    context.commit(SET_IS_DISABLED_USER, false);
                    resolve(response);
                }
            })
            .catch(({ response }) => {
                context.commit(SET_USER_LOADING, false);
                context.commit(SET_USER_ERROR, response.data.errors);
                context.commit(SET_IS_DISABLED_USER, true);
            });
        });
    },

    [CREATE_USER](context, payload) {
        context.commit(SET_USER_LOADING, false);
        context.commit(SET_IS_DISABLED_USER, true);
        context.commit(CLEAR_USER_ERROR);
        
        return ApiService.post("/user/store", payload.data)
        .then(( response ) => {
            if(response.data == 403) {
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde ekleme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                context.commit(CLEAR_USER_ERROR);
            }
            else{
                context.commit(SET_USER_LOADING, false);
                AlertService.makeToast(
                    "success",
                    "Kayıt Başarılı",
                    "Kullanıcı başarıyla kaydedilmiştir. ID numarası: " + response.data.id
                );
                context.commit(CLEAR_USER_ERROR);
                context.commit(SET_IS_DISABLED_USER, false);
                if(payload.goBack){
                    router.go(-1);    
                }
                return response;
            }
        })
        .catch(({ response }) => {
            context.commit(SET_USER_LOADING, false);
            context.commit(SET_USER_ERROR, response.data.errors);
            context.commit(SET_IS_DISABLED_USER, false);
            AlertService.makeToast(
                "danger",
                "Hata!",
                "Lütfen aşağıdaki hataları düzeltiniz veya eksiklikleri gideriniz."
            );
        });
    },

    [UPDATE_USER](context, payload) {
        context.commit(SET_USER_LOADING, true);
        context.commit(SET_IS_DISABLED_USER, true);
        context.commit(CLEAR_USER_ERROR);
        
        return ApiService.put(`/user/${payload.data.id}`, payload.data)
        .then((response) => {
            if(response.data == 403){
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde güncelleme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                
            }
            else{
                context.commit(SET_USER_LOADING, false);
                AlertService.makeToast(
                    "success",
                    "Güncelleme Başarılı",
                    payload.data.id + " ID numaralı kullanıcı başarıyla güncellenmiştir."
                );
            
                context.commit(SET_IS_DISABLED_USER, false);
                if(payload.goBack){
                    router.go(-1);    
                }
                
            return response;   
            }
                
        })
        .catch(({ response }) => {
            context.commit(SET_USER_LOADING, false);
            context.commit(SET_USER_ERROR, response.data.errors);
            context.commit(SET_IS_DISABLED_USER, false);
            AlertService.makeToast(
                "danger",
                "Hata!",
                "Lütfen aşağıdaki hataları düzeltiniz veya eksiklikleri gideriniz."
            );
            
        });
        
    },

    [DELETE_USER](context, payload) {
        context.commit(SET_USER_LOADING, true);
        context.commit(CLEAR_USER_ERROR);
        JwtService.getToken();
        ApiService.setHeader();
        ApiService.delete(`/user/${payload.itemToDelete}`)
        .then(( response ) => {
            context.commit(SET_USER_LOADING, false);
            
            if(response.data == 403){
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde silme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                
            }
            else{
                if(response.data == 401) {
                    AlertService.makeToast(
                        "warning",
                        "Silme Hatası",
                        "Silmeye çalıştığınız kullanıcı login olmuş kullanıcıyla aynıdır. Silme başarısız."
                    );
                }
                else{
                    AlertService.makeToast(
                        "success",
                        "Silme Başarılı",
                        payload.itemToDelete + " ID numaralı kullanıcı başarıyla silinmiştir."
                    );
                }
            }
        })
        .catch(( error ) => {
            context.commit(SET_USER_ERROR, error);
        });
        
    },

    [APPROVE_USER](context, payload) {
        context.commit(SET_USER_LOADING, true);
        context.commit(SET_IS_DISABLED_USER, true);
        context.commit(CLEAR_USER_ERROR);
        
        return ApiService.put(`/user/approve/${payload.data.id}`, payload.data)
        .then((response) => {
            
            if(response.data == 403){
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                
            }
            else{
                context.commit(SET_USER_LOADING, false);
                AlertService.makeToast(
                    "success",
                    "Güncelleme Başarılı",
                    payload.data.id + " ID numaralı kullanıcı başarıyla onaylanmıştır."
                );
            
                context.commit(SET_IS_DISABLED_USER, false);
                if(payload.goBack){
                    router.go(-1);    
                }
                
            return response;   
            }
                
        })
        .catch(({ response }) => {
            context.commit(SET_USER_LOADING, false);
            context.commit(SET_USER_ERROR, response.data.errors);
            context.commit(SET_IS_DISABLED_USER, false);
            AlertService.makeToast(
                "danger",
                "Hata!",
                "Lütfen aşağıdaki hataları düzeltiniz veya eksiklikleri gideriniz."
            );
            
        });
        
    },

    [EXPEL_USER](context, payload) {
        context.commit(SET_USER_LOADING, true);
        context.commit(SET_IS_DISABLED_USER, true);
        context.commit(CLEAR_USER_ERROR);
        
        return ApiService.put(`/user/expel/${payload.data.id}`, payload.data)
        .then((response) => {
            
            if(response.data == 403){
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                
            }
            else{
                context.commit(SET_USER_LOADING, false);
                AlertService.makeToast(
                    "success",
                    "Güncelleme Başarılı",
                    payload.data.id + " ID numaralı kullanıcı başarıyla ihraç edilmiştir."
                );
            
                context.commit(SET_IS_DISABLED_USER, false);
                if(payload.goBack){
                    router.go(-1);    
                }
                
            return response;   
            }
                
        })
        .catch(({ response }) => {
            context.commit(SET_USER_LOADING, false);
            context.commit(SET_USER_ERROR, response.data.errors);
            context.commit(SET_IS_DISABLED_USER, false);
            AlertService.makeToast(
                "danger",
                "Hata!",
                "Lütfen aşağıdaki hataları düzeltiniz veya eksiklikleri gideriniz."
            );
            
        });
        
    },

    [RESIGN_USER](context, payload) {
        context.commit(SET_USER_LOADING, true);
        context.commit(SET_IS_DISABLED_USER, true);
        context.commit(CLEAR_USER_ERROR);
        
        return ApiService.put(`/user/resign/${payload.data.id}`, payload.data)
        .then((response) => {
            
            if(response.data == 403){
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                
            }
            else{
                context.commit(SET_USER_LOADING, false);
                AlertService.makeToast(
                    "success",
                    "Güncelleme Başarılı",
                    payload.data.id + " ID numaralı kullanıcı başarıyla istifa ettirilmiştir."
                );
            
                context.commit(SET_IS_DISABLED_USER, false);
                if(payload.goBack){
                    router.go(-1);    
                }
                
            return response;   
            }
                
        })
        .catch(({ response }) => {
            context.commit(SET_USER_LOADING, false);
            context.commit(SET_USER_ERROR, response.data.errors);
            context.commit(SET_IS_DISABLED_USER, false);
            AlertService.makeToast(
                "danger",
                "Hata!",
                "Lütfen aşağıdaki hataları düzeltiniz veya eksiklikleri gideriniz."
            );
            
        });
        
    },

    [DEATH_USER](context, payload) {
        context.commit(SET_USER_LOADING, true);
        context.commit(SET_IS_DISABLED_USER, true);
        context.commit(CLEAR_USER_ERROR);
        
        return ApiService.put(`/user/death/${payload.data.id}`, payload.data)
        .then((response) => {
            
            if(response.data == 403){
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                
            }
            else{
                context.commit(SET_USER_LOADING, false);
                AlertService.makeToast(
                    "success",
                    "Güncelleme Başarılı",
                    payload.data.id + " ID numaralı kullanıcı başarıyla vefat statüsüne alınmıştır."
                );
            
                context.commit(SET_IS_DISABLED_USER, false);
                if(payload.goBack){
                    router.go(-1);    
                }
                
            return response;   
            }
                
        })
        .catch(({ response }) => {
            context.commit(SET_USER_LOADING, false);
            context.commit(SET_USER_ERROR, response.data.errors);
            context.commit(SET_IS_DISABLED_USER, false);
            AlertService.makeToast(
                "danger",
                "Hata!",
                "Lütfen aşağıdaki hataları düzeltiniz veya eksiklikleri gideriniz."
            );
            
        });
        
    },

    [ADD_ROLE_TO_USER](context, payload) {
        ApiService.post("/user/addRole", payload.data)
        .then(( response ) => {
            if(response.data == 403){
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde güncelleme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                
            }
            else{
                AlertService.makeToast(
                    "success",
                    "Ekleme Başarılı",
                    "Kullanıcı başarıyla kullanıcı rolüne dahil edilmiştir."
                );
            }   
        })
       
    },

    [DELETE_ROLE_FROM_USER](context, payload) {
        ApiService.delete(`/user/deleteRole/${payload.data.user_id}/${payload.data.role_id}`)
        .then(( response ) => {
            if(response.data == 403){
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde güncelleme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                
            }
            else{
                AlertService.makeToast(
                    "success",
                    "Silme Başarılı",
                    "Kullanıcı rolü başarıyla kullanıcıdan silinmiştir."
                );
            }   
        })
    },

    [ADD_PERMISSION_TO_USER](context, payload) {
        ApiService.post("/user/addPermission", payload.data)
        .then(( response ) => {
            if(response.data == 403){
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde güncelleme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                
            }
            else{
                AlertService.makeToast(
                    "success",
                    "Ekleme Başarılı",
                    "Kullanıcı başarıyla izne dahil edilmiştir."
                );
            }   
        })
       
    },

    [DELETE_PERMISSION_FROM_USER](context, payload) {
        ApiService.delete(`/user/deletePermission/${payload.data.user_id}/${payload.data.permission_id}`)
        .then(( response ) => {
            if(response.data == 403){
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde güncelleme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                
            }
            else{
                AlertService.makeToast(
                    "success",
                    "Silme Başarılı",
                    "İzin başarıyla kullanıcıdan silinmiştir."
                );
            }   
        })
    },
 
    
};

const mutations = {

    [SET_PAGINATED_USERS](state, paginatedUsers) {
        state.paginatedUsers = paginatedUsers.data;
    },

    [SET_ALL_USERS](state, users) {
        state.users = users;
    },

    [SET_USER_DATA](state, user_data) {
        state.user_data = user_data;
        state.errors = [];
    },

    [SET_USER_META](state, meta_user) {
        state.meta_user = meta_user;
    },

    [SET_USER_ERROR](state, error) {
        state.errors = error;
    },

    [CLEAR_USER_ERROR](state) {
        state.errors = [];
    },
    
    [SET_USER_LOADING](state, loading) {
        state.loading = loading;
    },

    [SET_IS_DISABLED_USER](state, isDisabled) {
        state.isDisabled = isDisabled;
    },

};

export default {
    state,
    actions,
    mutations,
    getters
};


